import React from "react";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import { Link } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const [t, i18n] = useTranslation("common");

  const changeLanguage = () => {
    const lang = i18n.language;
    i18n.changeLanguage(lang === "fr" ? "en" : "fr");
    localStorage.setItem("lang", lang);
  };

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoIcon />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            Erna
          </h1>
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {t("home")}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {t("services")}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="studies"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {t("studies")}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="tourism"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {t("tourism")}
          </Link>
        </li>
      </UlStyle>
      <UlStyle className="flexCenter">
        <li className="semiBold font15 pointer flexCenter">
          <Link onClick={() => toggleSidebar(!sidebarOpen)} to="contact" spy={true} smooth={true} offset={-80}>
            <a className="radius8 lightBg" style={{ padding: "10px 15px" }}>
              {t("contact")}
            </a>
          </Link>
        </li>
        <li className="semiBold font15 pointer" onClick={() => changeLanguage()}>
          <a style={{ padding: "10px 30px 10px 30px" }} className="whiteColor">
            {i18n.language.toUpperCase()}
          </a>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
